angular.module('impactx.cube').controller('NewCubeButtonCtrl', NewCubeButtonCtrl);

NewCubeButtonCtrl.$inejct = ['NewCubeService'];

function NewCubeButtonCtrl(NewCubeService){

    this.open = NewCubeService.open;

}